import TagFooter from "./TagFooter";
export default TagFooter;